export default "__VITE_ASSET__a1dc0a69__"